export enum AuthProvider {
    Apple = 'Apple',
    Microsoft = 'Microsoft',
    Google = 'Google',
    Email = 'Email'
}
